import { useEffect } from "react";
import { useTheme } from "./contexts/NewThemeContext";

export default function FaviconUpdater() {
  const { favicon } = useTheme() || {};

  useEffect(() => {
    if (favicon) {
      let favicon = document.querySelector("link[rel='icon']");
      if (!favicon) {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        favicon.type = "image/png";
        document.head.appendChild(favicon);
      }
      favicon.href = favicon;
    }
  }, [favicon]);

  return null;
}
